import React from 'react';
import Card from '@material-ui/core/Card';
import { Notification } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';
import Logo from '../../layout/svg/ci-new-logo.svg';
import Background from '../../layout/images/Coi-Hero-Banner-world-map.jpg';

export const styles = (theme) => ({
  main: {
    fontFamily: 'Roboto',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    height: '1px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0D4464',
    backgroundImage: `url(${Background})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center left',
    backgroundSize: 'cover',
  },
  card: {
    minWidth: 300,
    padding: '1em',
  },
  avatar: {
    display: 'flex',
    justifyContent: 'center',
    margin: '50px 0',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  icon: {
    backgroundColor: theme.palette.secondary[500],
  },
  toolbar: {
    margin: '0 1em',
  },
  logo: {
    maxWidth: '90%',
  },
  bntlink: {
    fontWeight: 500,
    textTransform: 'none',
    color: '#00a1a1',
  },
  overrides: {
    MuiButton: {
      root: {
        backgroundColor: '#ff9200 !important',
      },
    },
  },
});

const AuthLayoutMakrup = ({ children, classes, ...props }) => (
  <div className={classes.main}>
    <Card className={classes.card}>
      <div className={classes.avatar}>
        <img src={Logo} alt="Cookie Information logo" className={classes.logo}/>
      </div>
      {children}
    </Card>
    <Notification/>
  </div>
);

export const AuthLayout = withStyles(styles)(AuthLayoutMakrup);
